import { MechanicalAspectItemComponentBase } from './mechanical-aspect-item.component.base';
import { Component, ElementRef, Injector, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { CrudEditorParentService, CrudEditorSelfService, requiredIfValidator, UserStorage } from '@scisys-uim/uim-common';
import { Asset, RefCode } from 'assets-model';
import { MechanicalAspectService, RefCodeStorage } from 'assets-service';


@Component({
  selector: 'app-mechanical-aspect-item',
  templateUrl: './mechanical-aspect-item.component.html',
  styleUrls: ['./mechanical-aspect-item.component.scss'],
  providers: [CrudEditorParentService],
  viewProviders: [CrudEditorSelfService]
})
export class MechanicalAspectItemComponent extends MechanicalAspectItemComponentBase {

  @Input()
  asset: Asset;

  ragStatusSelectionList: RefCode[];

  constructor(protected mechanicalAspectService: MechanicalAspectService,
    protected refCodeStorage: RefCodeStorage,
    protected fb: FormBuilder,
    protected elementRef: ElementRef,
    protected router: Router,
    protected route: ActivatedRoute,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected injector: Injector,
    protected snackbar: MatSnackBar) {
    super(mechanicalAspectService, refCodeStorage, fb, elementRef, router, route, userStorage, dialog, injector, snackbar);
  }

  createForm(): FormGroup {
    return this.fb.group({
      havs: [null],
      havsRagStatus: [null],
      wbv: [null],
      wbvRagStatus: [null]
    }, {
      validators: [
        requiredIfValidator(() => this.havsRagStatus, () => this.item.havs, "HAVS R/A/G Status", { required: "HAVS R/A/G Status is required when HAVS flag is on." }),
        requiredIfValidator(() => this.wbvRagStatus, () => this.item.wbv, "WBV R/A/G Status", { required: "WBV R/A/G Status is required when WBV is flag is on." }),
      ]
    });
  }

  protected onInitAsyncComplete() {
    super.onInitAsyncComplete();
    this.ragStatusLoadSelectionList();
  }

  ragStatusLoadSelectionList() {
    this.refCodeStorage.getDomainElements('RAG_STATUS').subscribe(
      data => {
        this.ragStatusSelectionList = data.sort((a, b) => (a.val1Num - b.val1Num));
      }
    );
  }

  itemSet() {
    super.itemSet();
  }

  setDefaultDisabledFields(): void {
    super.setDefaultDisabledFields();

    this.havsRagStatus?.disable();
    if (this.item.havs) {
      this.havsRagStatus?.enable();
    }

    this.wbvRagStatus?.disable();
    if (this.item.wbv) {
      this.wbvRagStatus?.enable();
    }
  }

  havsChangedByUser(value: boolean, unsetDependents?: boolean): void {
    super.havsChangedByUser(value, unsetDependents);
    if (value) {
      this.havsRagStatus.enable();
    } else {
      this.havsRagStatus.disable();
      this.item.havsRagStatus = null;
    }
  }

  wbvChangedByUser(value: boolean, unsetDependents?: boolean): void {
    super.wbvChangedByUser(value, unsetDependents);
    if (value) {
      this.wbvRagStatus.enable();
    } else {
      this.wbvRagStatus.disable();
      this.item.wbvRagStatus = null;
    }
  }

}





